import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '电视剧', to: '/category?type=%E7%94%B5%E8%A7%86%E5%89%A7' },
  { label: '电影', to: '/category?type=%E7%94%B5%E5%BD%B1' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const solid = !isHome || scrolled;

  const isActive = (to: string) => {
    const [path, query] = to.split('?');
    if (path === '/') return location.pathname === '/' && !location.search;
    if (path === '/category') {
      if (location.pathname !== '/category') return false;
      const type = new URLSearchParams(location.search).get('type');
      const target = query ? new URLSearchParams(query).get('type') : null;
      return type === target;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed left-0 top-0 z-50 w-full transition-all duration-300 ${
        solid
          ? 'border-b border-background-200/70 bg-background-50/95 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between px-4 md:h-[72px] md:px-10">
        <Link to="/" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              solid ? 'bg-primary-600 text-background-50' : 'bg-primary-600 text-background-50'
            }`}
          >
            <i className="ri-play-circle-fill text-xl"></i>
          </span>
          <span
            className={`font-heading text-lg font-extrabold tracking-tight md:text-xl ${
              solid ? 'text-foreground-950' : 'text-background-50 drop-shadow'
            }`}
          >
            伊人在线
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className={`whitespace-nowrap cursor-pointer rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? solid
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-background-50/20 text-background-50'
                  : solid
                    ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-700'
                    : 'text-background-100 hover:bg-background-50/20 hover:text-background-50'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            aria-label="搜索影视"
            className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-full transition-colors md:h-10 md:w-10 ${
              solid
                ? 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                : 'bg-background-50/20 text-background-50 hover:bg-background-50/30'
            }`}
          >
            <i className="ri-search-line text-lg"></i>
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-full transition-colors md:hidden ${
              solid
                ? 'bg-background-100 text-foreground-700'
                : 'bg-background-50/20 text-background-50'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className={`cursor-pointer rounded-md px-3 py-3 text-sm font-medium ${
                  isActive(item.to)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/search"
              className="mt-1 cursor-pointer rounded-md px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100"
            >
              搜索影视
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}